/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.getServiceAuth'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  aud: /*#__PURE__*/ l.string({ maxLength: 2048 }),
  exp: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  lxm: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'nsid' })),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  token: /*#__PURE__*/ l.string(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get a signed token on behalf of the requesting DID for the requested service. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['BadExpiration'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
